import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const figma = defineConnector({
  identifier: "figma",
  name: "Figma",
  tagLine: "Design and prototyping",
  logo,
  protocol: "http",
  tags: ["featured", "productivity"],
  defaultUrlPattern: () => "https://api\\.figma\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Connect your Figma account",
      items: [
        {
          kind: "oauth",
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "authorization_code",
    authorizationEndpoint: () => "https://www.figma.com/oauth",
    tokenEndpoint: () => "https://api.figma.com/v1/oauth/token",
    tokenEndpointAuthMethod: () => "client_secret_basic",
    clientCredentialsFrom: "env",
  },
  connectionTest: {
    protocol: "http",
    request: () => "https://api.figma.com/v1/me",
  },
});
